export const PERMISSIONS = {
    USERS: {
        VIEW: 'users.view',
        CREATE: 'users.create',
        EDIT: 'users.edit',
    },
    IDEAS: {
        VIEW: 'ideas.view',
        CREATE: 'ideas.create',
        EDIT: 'ideas.edit',
    },
    TAGS: {
        VIEW: 'tags.view',
        CREATE: 'tags.create',
        EDIT: 'tags.edit',
        DELETE: 'tags.delete',
    },
    EVENTS: {
        VIEW: 'events.view',
        CREATE: 'events.create',
        EDIT: 'events.edit',
        PUBLISH: 'events.publish',
    },
}